import { OptionCombination } from './option-combination';
import { PanoBlend } from './pano-blend';
import { View } from './view';

export class PanoHistory {
  optionCombo: OptionCombination;
  view: View;
  blend?: PanoBlend;
}
